// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 912) return "awsutilityVendor.d826d93b3f6f4dd69c47.js";
	if (chunkId === 123) return "muiVendor.776d22126ff8c0e5707b.js";
	// return url for filenames based on template
	return "chunk." + chunkId + ".js";
};